// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec637579","879":"e81494b4"}[chunkId] + ".chunk.js";
};